import { Box, Typography, useTheme } from '@mui/material';
import { IconBox, NavigateListItemStyled } from './style';
import { CustomAccordion } from '../../../components/Accordion';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import AccountingIcon from '../../../icons/AccountingIcon';
import ManagementIcon from '../../../icons/ManagementIcon';
import SpeakerIcon from '../../../icons/SpeakerIcon';
import TechIcon from '../../../icons/TechIcon';
import PersonIconTwo from '../../../icons/PersonIconTwo';
import FormationIcon from '../../../icons/FormationIcon';
import TaxPlanningIcon from '../../../icons/TaxPlanningIcon';
import PaperBoxIcon from '../../../icons/PaperBoxIcon';
import HandShakeIcon from '../../../icons/HandShakeIcon';

function NavigationItem({ item, setSelectedItem, selectedItemDetails, selectedItem, drawerOpen, expandedItemId, setExpandedItemId }) {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    const handleClick = (cItem) => {
        selectedItemDetails = {
            selectedNavId: item.id,
            selectedListItemId: cItem.id,
        };
        setSelectedItem({ ...cItem });

        // const newSelectedItemDetials = {
        //     selectedNavId: item.id,
        //     selectedListItemId: cItem.id,
        // };

        const newParams = new URLSearchParams(location.search);
        newParams.set('selectedNavId', item.id);
        newParams.set('selectedListItemId', cItem.id);
        navigate(`${location.pathname}?${newParams.toString()}`);

        //handling drawer state in useEffect of index file
        // drawerOpen();
    };

    useEffect(() => {
        if (item.id === selectedItemDetails.selectedNavId) {
            setExpandedItemId(item.id);
        }
    }, [selectedItemDetails.selectedNavId]);

    const getIcon = (status) => {
        if (status === 'LLC Formation') {
            return <FormationIcon />;
        } else if (status === 'Banking & Accounting') {
            return <AccountingIcon />;
        } else if (status === 'Tax Planning') {
            return <TaxPlanningIcon />;
        } else if (status === 'Legal & Compliance') {
            return <PaperBoxIcon />;
        } else if (status === 'Risk Management') {
            return <ManagementIcon />;
        } else if (status === 'Branding & Marketing') {
            return <SpeakerIcon />;
        } else if (status === 'IT & Technology') {
            return <TechIcon />;
        } else if (status === 'Human Resources') {
            return <PersonIconTwo />;
        } else if (status === 'Public Relations') {
            return <HandShakeIcon />;
        }
    };

    const SummaryUI = (
        <>
            <IconBox className="outer-list-item-icon" component="div">
                {item.name === 'Public Relations' ? getIcon('Public Relations') : getIcon(item.icon)}
            </IconBox>
            <Box sx={{ ml: 2, display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'start' }}>
                <Typography component="h2" variant="paraText2" color={'text.primary'}>
                    {item.name}
                </Typography>
                {/* <Box>
                    <Typography variant="body2" color={'text.tertiary'}>
                        {item.solutions?.length ? item.solutions?.length : 0} Suggested Solutions
                    </Typography>
                </Box> */}
            </Box>
        </>
    );

    const detailsUI = (
        <>
            {item?.solutions.map((cItem) => (
                <Box
                    key={cItem.id}
                    id={cItem.id}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginLeft: `3rem`,

                        padding: `${theme.typography.generic.xSmall}`,

                        borderRadius: theme.typography.borderRadius.xxSmall,

                        ...(selectedItem.id === cItem.id && {
                            '& .MuiTypography-root': {
                                color: theme.palette.primary.main,
                            },
                        }),

                        '&:not(:last-child)': {
                            marginBottom: '0.5rem',
                        },

                        cursor: 'pointer',
                    }}
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                        handleClick(cItem);
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            handleClick(cItem);
                        }
                    }}
                >
                    <Typography variant="paraText4" color={'text.secondary'}>
                        {cItem.name}
                    </Typography>
                </Box>
            ))}
        </>
    );

    return (
        <CustomAccordion
            sx={{
                '&.Mui-expanded': {
                    border: `1px solid ${theme.palette.border.neutralPrimary}`,
                    background: theme.palette.background.neutralSecondary,
                },

                '& .MuiAccordionDetails-root:first-of-type': {
                    marginTop: `${theme.typography.generic.xLarge}`,
                },
            }}
            component={NavigateListItemStyled}
            details={detailsUI}
            summary={SummaryUI}
            onChange={() => {
                //if accordion expanded then can close or vice versa
                const expandedId = item.id === expandedItemId ? '' : item.id;
                setExpandedItemId(expandedId);
            }}
            expanded={item.id === expandedItemId || false}
        ></CustomAccordion>
    );
}

export default NavigationItem;
